export default "__VITE_ASSET__db35bbd5__"